export const COMMON = {
 TOKEN_CHECK_INTERVAL: 30000,
 MIN_VALIDITY_BEFORE_EXPIRY: 60,
}

export enum DEFAULT_LANG_NAME {
 'hi' = 'हिन्दी',
 'en' = 'English',
 'mr' = 'मराठी',
 'bn' = 'বাংলা',
 'or' = 'ઓડિયા',
 'gu' = 'ગુજરાતી',
 'ta' = 'தமிழ்',
 'te' = 'తెలుగు',
 'kn' = 'கன்னடம்',
 'ml' = 'மலையாளம்',
}

export const COOKIE_MAX_AGE_1YEAR = 31536000
const DEHAAT_WHATSAPP_SUPPORT_NUMBER = '8506909095'
export const DEFAULT_LANG = 'en'
export const REDIRECT_URI_KEY = 'redirect_uri'

export const ACCESS_TOKEN_KEY = 'farm_rise_token'
export const REFRESH_TOKEN_KEY = 'farm_rise_refresh_token'

export const MIN_TOKEN_VALIDITY_MINUTE = 1

export const GET_WHATSAPPHANDLER_API = (
 message: string
) => {
 const url = `https://api.whatsapp.com/send/?phone=+91${DEHAAT_WHATSAPP_SUPPORT_NUMBER}&text=${encodeURI(
  message
 )}`
 return url
}

export const WEBSITE_NAME = 'farm_rise'
export const WEBSITE_URL = 'https://digiacre.com'

export const categoryList = [
 {
  key: '',
  value: 'All',
 },
 {
  key: 'Active',
  value: 'Active',
 },
 {
  key: 'Inactive',
  value: 'Inactive',
 },
]

export const DEFAULT_TEMPLATE_VARIABLES = [
 'aggregator_centre_name',
 'price',
 'aggregator_phone_number',
]

export const cropCategoryList = [
 {
  key: '',
  value: 'All',
 },
 {
  key: 'FV',
  value: 'F&V',
 },
 {
  key: 'DRY',
  value: 'Dry',
 },
]

export const cropCategoryOptions = [
 {
  id: 'FV',
  name: 'F&V',
 },
 {
  id: 'DRY',
  name: 'Dry',
 },
]

export const tutorialList = [
 {
  key: '',
  value: 'PMU',
 },
 {
  key: 'DISTRIBUTOR',
  value: 'DISTRIBUTOR',
 },
 {
  key: 'AGGREGATOR',
  value: 'AGGREGATOR',
 },
 {
  key: 'AGENT',
  value: 'AGENT',
 },
]
